// App-side delegate for `@heidi/templates/data` (ARCFE-1019).
//
// `useIsOwnTemplate` stays here: it is app composition over another templates
// query, and it is exported for existing consumers. `useIsReviewingOtherUser`
// is a WORKSPACE fact — pulling it into the package would forge a
// templates -> workspace edge for one boolean, so the two are combined here and
// the decision crosses as `skipCheckOwnTemplate` (cohort-C).
import { useIsReviewingOtherUser } from '@/hooks/query/useQueryUser';
import { type Maybe } from '@/types';
import { type GenerationMethod } from '@heidi/schema/ml-scribe';
import { GET_TEMPLATE_BY_ID } from '@heidi/templates/contracts';
import { useQueryTemplateById as useQueryTemplateByIdCore } from '@heidi/templates/data';
import { useQueryDocumentTemplates } from './useQueryDocumentTemplates';

export { GET_TEMPLATE_BY_ID };

export function useIsOwnTemplate(templateId: Maybe<string>) {
  const { data: templates } = useQueryDocumentTemplates();
  if (!templates) return false;
  return templates.some((template) => template.id === templateId);
}

export function useQueryTemplateById(
  templateId: Maybe<string>,
  generationMethod: Maybe<GenerationMethod>
) {
  const isOwnTemplate = useIsOwnTemplate(templateId);
  const isReviewingOtherUser = useIsReviewingOtherUser();
  const skipCheckOwnTemplate = isReviewingOtherUser ? isOwnTemplate : true;

  return useQueryTemplateByIdCore(templateId, generationMethod, skipCheckOwnTemplate);
}
